import ContactPage from '../components/Contact/Contact';

export default function Contact() {
  return <ContactPage />;
}
